module.exports = __webpack_public_path__ + "img/logo-white.1c5f232d.png";